module.exports = __webpack_public_path__ + "img/awaiting-payment.ce0cc955.svg";